import { useEffect, useState, useMemo } from "react";
import { SelectOption } from "../globals/interfaces";

export default function useSelection (commaSeparatedString: string, key?: string) {
    const [selected, setSelected] = useState<Array<SelectOption>>([]);

    useEffect(() => {
        const stringArray = (commaSeparatedString || '').split(',');
        const optionsArray: Array<SelectOption> = [];
        stringArray.map(string => string.length > 0 && optionsArray.push({ label: string, value: string }));
        setSelected(optionsArray);
    }, [commaSeparatedString, key]);

    const selectedString = useMemo(() => {
        return selected.map(s => s.value).join(',');
    }, [selected]);

    return {
        selected, 
        setSelected,
        selectedString
    }
}